"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConfirmationMessage = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const Typography_1 = require("../../../atoms/Typography");
const MessageContainer = styled_components_1.default.div `
  text-align: center;
  display: flex;
  flex-wrap: wrap;
  max-width: 17rem;
  justify-content: center;
`;
const ConfirmationMessage = ({ message, }) => {
    return (react_1.default.createElement(MessageContainer, null,
        react_1.default.createElement(Typography_1.H4, null, message)));
};
exports.ConfirmationMessage = ConfirmationMessage;
